import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AgmMap } from './agm-map.component';
import { AgmMarker } from './agm-marker.component';
import { MapsAPILoader } from './maps-api-loader';

@NgModule({
  imports: [CommonModule],
  declarations: [AgmMap, AgmMarker],
  exports: [AgmMap, AgmMarker],
  providers: [MapsAPILoader]
})
export class AgmCompatModule {
  static forRoot(): ModuleWithProviders<AgmCompatModule> {
    return { ngModule: AgmCompatModule, providers: [MapsAPILoader] };
  }
}
